var map = {
	"./LOGO.png": 1537,
	"./bg-2.jpg": 2928,
	"./bg-3.jpg": 4061,
	"./bg-4.jpg": 9302,
	"./colorful-pills-syringe.jpg": 8613,
	"./copy-space-tablets-with-pills.jpg": 8974,
	"./favicon.jpg": 6510,
	"./favicon.png": 7514,
	"./galleryimg 1.png": 1010,
	"./galleryimg 2.png": 745,
	"./galleryimg 3.png": 4496,
	"./galleryimg 4.png": 6719,
	"./galleryimg 5.png": 7702,
	"./galleryimg 6.png": 8909,
	"./high-angle-pills-blue-background.jpg": 4259,
	"./logo-final.png": 7562,
	"./logo1.jpeg": 5457,
	"./main.jpg": 247,
	"./medicine-capsules-global-health-with-geometric-pattern-digital-remix.jpg": 1329,
	"./mission bg.png": 4947,
	"./mission img.png": 9849,
	"./mission new.png": 4078,
	"./overview.jpg": 121,
	"./packings-pills-capsules-medicines.jpg": 278,
	"./pills-frame-blue-background.jpg": 4004,
	"./product-img/DOMESO-RSP.jpg": 8405,
	"./product-img/Glujic-soap.png": 3772,
	"./product-img/ROOPAN-40.jpg": 2182,
	"./product-img/ROOPAN-DSR.jpg": 5231,
	"./product-img/RSP-MONTILEV.jpg": 3146,
	"./product-img/SWAS D-MR.jpg": 3102,
	"./product-img/SWAS D-SP.jpg": 7922,
	"./product-img/SWAS-A-SP.jpg": 876,
	"./product-img/SWAS-AP.jpg": 572,
	"./product-img/SWASGLIM-M1.jpg": 5000,
	"./product-img/SWASGLIM-M2.jpg": 5927,
	"./product-img/SWASMOL-650.jpg": 4036,
	"./product-img/SWASOM.jpg": 3044,
	"./product-img/SWASRAB-DSR.jpg": 3689,
	"./product-img/TELSWA-40.jpg": 3263,
	"./product-img/TELSWA-H.jpg": 7595,
	"./product-img/Tape L.jpg": 7410,
	"./product-img/Tape M.jpg": 7407,
	"./product-img/Tape XL.jpg": 5008,
	"./product-img/babify.jpeg": 2526,
	"./product-img/bumkins.jpg": 8685,
	"./product-img/ketoroob-soap.png": 503,
	"./product-img/kiah-organic-pads-XL+.jpg": 7190,
	"./product-img/kiah-organic-pads-XXL.jpg": 9025,
	"./product-img/klara.jpg": 6685,
	"./product-img/pant L.jpg": 5809,
	"./product-img/pant M.jpg": 7284,
	"./product-img/pant XL.jpg": 7205,
	"./product-img/sample.jpg": 9100,
	"./product-img/sanitary-pads-R.jpg": 3829,
	"./product-img/sanitary-pads-XL.jpg": 1723,
	"./rooba logo.jpg": 1844,
	"./stethoscope-medicine-desk.jpg": 2980,
	"./value bg.png": 7412,
	"./value img.png": 4376,
	"./values-01.png": 3088,
	"./vecteezy_man-pointing-at-a-wooden-block-communication-concept-with_21698967.jpg": 8300,
	"./vision bg.png": 5091,
	"./vision img.png": 1193,
	"./vision new.png": 8046,
	"./why-us.jpg": 1015
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;